export const getters = {
  temoins(state) {
    return state.temoins;
  },
  temoin(state) {
    return state.temoin;
  },
  pagination(state) {
    return state.pagination;
  },
};
